var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.061 3.03418C10.5722 3.03418 7.70523 5.86177 7.70523 9.37901V19.31C7.70523 19.6894 8.01611 19.9997 8.39608 19.9997H11.9885C12.3684 19.9997 12.6793 19.6894 12.6793 19.31V9.65487C12.6793 8.89625 13.3011 8.27556 14.061 8.27556C14.8209 8.27556 15.4427 8.89625 15.4427 9.65487V19.31C15.4427 19.6894 15.7536 19.9997 16.1336 19.9997H19.726C20.1059 19.9997 20.4168 19.6894 20.4168 19.31V9.37901C20.4168 5.89625 17.5843 3.03418 14.061 3.03418Z",
    fill: "#64ffda"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90371 0C1.52202 0 0.416664 1.10345 0.416664 2.48276C0.416664 3.86207 1.52202 4.96552 2.90371 4.96552C4.2854 4.96552 5.39076 3.86207 5.39076 2.48276C5.39076 1.10345 4.2854 0 2.90371 0Z",
    fill: "#64ffda"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69991 6.27539H1.10751C0.727545 6.27539 0.416664 6.58574 0.416664 6.96505V19.3099C0.416664 19.6892 0.727545 19.9995 1.10751 19.9995H4.69991C5.07988 19.9995 5.39076 19.6892 5.39076 19.3099V6.96505C5.39076 6.58574 5.07988 6.27539 4.69991 6.27539Z",
    fill: "#64ffda"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/Linkedin_icon.7e999a434b077103e42ceeef20ca4854.svg";
export { ForwardRef as ReactComponent };